// Utility helpers for locale-aware redirects and safe `next` handling
export function buildAdminLoginUrl(locale: string, next?: string) {
  // Return an unprefixed admin login path. The i18n-aware router will add
  // the appropriate locale prefix automatically. Avoid returning a path
  // that already contains the locale to prevent double-prefixing.
  if (next) {
    const encoded = encodeURIComponent(next)
    return `/admin?next=${encoded}`
  }
  return `/admin`
}

// Push a safe redirect after login. Only allows relative paths starting with '/'.
export function resolveNextOrFallback(
  nextParam: string | null,
  locale: string,
  fallbackPath = `/admin/dashboard`
) {
  if (!nextParam) return `${fallbackPath}`
  try {
    const decoded = decodeURIComponent(nextParam)
    // Only allow same-origin relative paths
    if (decoded.startsWith('/')) {
      // If decoded path already contains a leading locale (e.g. '/ms-MY/...'),
      // strip it so the i18n router can reapply the correct locale once.
      const localePrefix1 = `/${locale}`
      const localePrefix2 = `/${locale.split('-')[0]}` // handle 'en' vs 'ms-MY'
      if (decoded.startsWith(localePrefix1)) {
        return decoded.replace(localePrefix1, '') || '/'
      }
      if (decoded.startsWith(localePrefix2)) {
        return decoded.replace(localePrefix2, '') || '/'
      }
      return decoded
    }
  } catch (e) {
    // ignore malformed encoding
  }
  return `${fallbackPath}`
}
